import React, { PureComponent } from 'react';

import { cookieInfo, cookieInfoContainer } from './styles.module.css';

class CookiePolicy extends PureComponent {
  render() {
    return (
      <div className={cookieInfoContainer}>
        <div className={cookieInfo}>
          <h1>Cookie Policy </h1>
          <p>
            Like most websites, we use cookies. By using the Let’s Do This
            website you agree to our use of cookies.
          </p>

          <h3>What is a cookie?</h3>
          <p>
            We use cookies in a range of ways to improve your experience on our
            site. A cookie is a small file that can be placed on your device
            that allows us to recognise and remember you. Cookies let us show
            you things which are relevant to you, based on information you’ve
            entered and stuff you’ve looked at.
            <br />
            <br />
            This page describes what information is in our cookies, how we use
            it and why we sometimes need to store these cookies. We will also
            share how you can prevent these cookies from being stored. However,
            this may downgrade or break certain elements of the sites
            functionality.
          </p>

          <h3>Disabling Cookies</h3>
          <p>
            You can prevent the setting of cookies by adjusting the settings on
            your browser (see your browser Help for how to do this). Be aware
            that disabling cookies will affect the functionality of Let’s Do
            This and many other websites that you visit.
          </p>

          <h3>The Cookies We Set</h3>
          <h4>Account related cookies</h4>
          <p>
            If you create an account with us then we’ll use cookies for the
            management of the signup process and general administration. These
            cookies will usually be deleted when you log out however in some
            cases they may remain afterwards to remember your site preferences
            when logged out.
          </p>
          <h4>Login related cookies</h4>
          <p>
            We use cookies when you’re logged in so that we can remember this
            fact. This prevents you from having to log in every single time you
            visit a new page. These cookies are typically removed or cleared
            when you log out to ensure that you can only access restricted
            features and areas when logged in.
          </p>
          <h4>Email newsletter related cookies</h4>
          <p>
            We offer newsletter or email subscription services and cookies may
            be used to remember if you are already registered and whether to
            show certain notifications which might only be valid to
            subscribed/unsubscribed users.
          </p>
          <h4>Site preferences cookies</h4>
          <p>
            In order to provide you with a great experience on Let’s Do This we
            provide the functionality to set your preferences for how this site
            runs when you use it. In order to remember your preferences we need
            to set cookies so that this information can be called whenever you
            interact with a page that’s affected by your preferences.
          </p>
          <h4>Third party cookies</h4>
          <p>
            In some special cases we also use cookies provided by trusted third
            parties. The following section details which third party cookies you
            might encounter through this site. This site uses Google Analytics
            which is one of the most widespread and trusted analytics solutions
            on the web for helping us to understand how you use the site and
            ways that we can improve your experience. These cookies may track
            things such as how long you spend on the site and the pages that you
            visit so we can continue to produce engaging content. For more
            information on Google Analytics cookies, see the official Google
            Analytics page. From time to time we test new features and make
            subtle changes to the way that the site is delivered. When we are
            still testing new features these cookies may be used to ensure that
            you receive a consistent experience whilst on the site whilst
            ensuring we understand which optimisations our users appreciate the
            most. As we sell products, it is important for us to understand
            statistics about how many of the visitors to our site actually make
            a purchase and as such this is the kind of data that these cookies
            will track. This is important to you as it means that we can
            accurately make business predictions that allow us to monitor our
            advertising and product costs to ensure the best possible price. We
            also use social media buttons and/or plugins on this site that allow
            you to connect with your social network in various ways. For these
            to work the following social media sites including Strava and
            Facebook will set cookies through our site which may be used to
            enhance your profile on their site or contribute to the data they
            hold for various purposes outlined in their respective privacy
            policies.
          </p>
          <h3>More Information</h3>
          <p>
            Hopefully that has clarified things for you, but if you’re looking
            for more information then please feel free to contact our 24/7
            customer support team.
          </p>
        </div>
      </div>
    );
  }
}

export default CookiePolicy;
